import { ResponsePaginationTableConverter } from "@converters/response-pagination-table.converter";
import gateway from "@interceptors/gateway.interceptor";
import { BaseService } from "@services/base.service"
import axios from "axios";
import { EXTERNAL_SERVICES_ENUM } from "@webkit/enums/external-services.enum";

class AccomodationService extends BaseService {
    private respPagConverter = new ResponsePaginationTableConverter()

    public createAccomodation = async (formData: FormData) => {
        const url = `/accomodation/save`;
        const response = await gateway.post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return response.data;
    };

    public updateAccomodation = async (id:number, formData: FormData, body: Object) => {
        const url = `/accomodation/update/${id}`;
        const bodyJsonString = JSON.stringify(body);
        formData.append('body', new Blob([bodyJsonString], { type: 'application/json' }));
        const response = await gateway.put(url, formData);
        return response.data;
    }

    public getAccomodationWithAllCardTitlesById = async (id: number) => {
        const url = `/accomodation/get-accomodation-with-all-card-titles/${id}`;
        const response = await gateway.get(url);
        return response.data;
    }

    public findAccomodationById = async (accomodationId: string) => {
        const url = `/accomodation/get-accomodation-from-id`;
        const response = await gateway.get(url, {
            params: {
                "id": accomodationId
            }
        });
        return response.data;
    }

    public findAccomodationAssociated = async (sort: Object) => {
        const url = `/accomodation/find-all-accomodation-associated`;
        const response = await gateway.get(url, {
            params: sort
        });
        const finalResponse = this.respPagConverter.dtoToModel(response.data)
        return finalResponse;
    };

    public updatePhotos = async (formData: FormData, accomodationId: string) => {
        const url = `/photo/update`;
        
        await gateway.put(url, formData, {
            params: {
                "accomodationId": accomodationId
            }
        });

    }

    public findPhotosFromAccomodation = async (idAccomodation: string) => {
        const url = `/photo/find-all-by-accomodation-id/${idAccomodation}`
        const response = await gateway.get(url);
        return response.data;
    }

    public deleteAccomodation = async (id: number) => {
        const url = `/accomodation/delete/${id}`
        const response = await gateway.delete(url);
        return response.data;
    }

    public getLongitudeAndLatitude = async (params: object) => {
        const url = `${EXTERNAL_SERVICES_ENUM.NOMINATIM_OPENSTREET_MAP}/search`
        const response = await axios.get(url, { params });
        return response.data;
    }

    public checkAccomodationLatLon = async (params: object) => {
        const url = `${EXTERNAL_SERVICES_ENUM.NOMINATIM_OPENSTREET_MAP}/reverse`;
        const response = await axios.get(url, { params });
        return response.data;
    }

    public changeVisibility = async (idAccomodation: string) => {
        const url = `/accomodation/change-state/${idAccomodation}`;
        const response = await gateway.put(url);
        return response.data;
    }

    public dowloadQrcodeId = async (idAccomodation: string) => {
        const url = `/accomodation/get-QrCode`;
        const response = await gateway.get(url, {
            params: { id: idAccomodation },
            responseType: 'blob',
        });
        return response.data; 
    };

    // recupero di crediti liberi e accomodation attive
    public getRemainCredit = async()=>{
        const url = `/host/get-info-about-credit`
        const response = await gateway.get(url)
        return response.data 
    } 

    public shareAccomodation = async(emails: string[], id: number, qrCodeId: string) => {
        const url = '/accomodation/send-email';
        const response = await gateway.post(url, {
            emails,
            accommodationId: id,
            qrCodeId: qrCodeId
        }, {
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return response.status;
    }

}
export default new AccomodationService();